import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-1" }, "Acceptance of cover", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "item-body pb-0" }, " Please review and confirm the application summary is complete and correct, and read and acknowledge the acceptance of cover ", -1)
const _hoisted_3 = { class: "pb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "item-tertiary-title smaller-text pb-2" }, "Application summary", -1)
const _hoisted_5 = { class: "item-content mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " I hereby confirm that all the information supplied for this application, by or about any of the Insured, the Policy Owner and/or the Premium Payer is correct, and the provider is authorised to give it to you. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionnaireAnswerSectionComponent = _resolveComponent("QuestionnaireAnswerSectionComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionnaireAnswers, (qa, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_QuestionnaireAnswerSectionComponent, {
            title: qa.title,
            "sub-sections": qa.questionnaireAnswerSubSections,
            "is-mobile-screen": _ctx.isMobileScreen
          }, null, 8, ["title", "sub-sections", "is-mobile-screen"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", null, [
        _createTextVNode(" I confirm that I want to proceed with the Offer of Insurance and by payments being made, I accept and understand the terms of the policy as described in the "),
        _createElementVNode("a", {
          class: "link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile(_ctx.policyDocumentLink)))
        }, _toDisplayString(_ctx.policyDocumentLink.linkText), 1),
        _createTextVNode(" and the "),
        _createElementVNode("a", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadFile(_ctx.offerLetterLink)))
        }, _toDisplayString(_ctx.offerLetterLink.linkText), 1),
        _createTextVNode(". I agree that this confirmation is also given on behalf of the policy owners (which I am authorised to do). ")
      ])
    ])
  ]))
}